import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("canvas", {
    id: $props.id,
    ref: "barCanvas",
    style: _normalizeStyle([{"height":"100%","width":"100%"}, $props.styleBarChart])
  }, null, 12, _hoisted_1))
}